import { createContext, useContext, useLayoutEffect } from 'react';

/**
 * Page plein écran (ADR-145 §11, addendum du 2026-10-20) : une page qui le demande se rend hors de la
 * coquille de l'application — ni barre du haut, ni menu latéral, ni fil d'Ariane, ni filigrane —, comme un
 * éditeur de Wix, Webflow, Framer ou Odoo. Option du socle des studios, jamais un cas d'un studio : la page
 * la demande tant qu'elle est montée, la coquille obéit. Sans fournisseur (tests), rien ne se passe.
 */
export const FullScreenContext = createContext<((on: boolean) => void) | null>(null);

/** Demande le plein écran tant que la page est montée. */
export function useFullScreenPage(on = true): void {
  const request = useContext(FullScreenContext);
  useLayoutEffect(() => {
    if (request === null || !on) return undefined;
    request(true);
    return () => request(false);
  }, [request, on]);
}
